import React from "react";
import Header from "../components/Header";
import PriceTable from "../components/PriceTable";
import Footer from "../components/Footer";

const Partnerpricerbracket=()=>{

return(
<>

<div className="home">
<div id="page" className="hfeed page-wrapper">
        <Header/>
        <h3 style={{textAlign:"center"}}>Price Brackets and Markup with Calculations</h3>
        <PriceTable/>
        <Footer/>
    </div>
</div>



</>


);


};
export default Partnerpricerbracket